<script lang="ts" setup>
import { RouterLink, type RouterLinkProps } from 'vue-router'

withDefaults(
  defineProps<{
    size?: string
    containerClass?: string
    to?: RouterLinkProps['to']
  }>(),
  {
    size: 'w-10',
    containerClass: 'flex h-9 w-12 items-center justify-center rounded-lg p-1',
    to: () => ({ name: 'home' }),
  },
)
</script>

<template>
  <RouterLink :to="to">
    <div :class="containerClass">
      <img src="@/assets/TWLTwhitelogo.png" alt="Logo" :class="size" />
    </div>
  </RouterLink>
</template>
